import Vue from 'vue'
import Vuex from 'vuex'
import * as auth from './modules/auth.js'
import * as clients from './modules/clients.js'
import * as students from './modules/students.js'
import * as schools from './modules/schools.js'
import * as classtypes from './modules/class-types.js'
import * as users from './modules/users.js'
import * as roles from './modules/roles.js'
import * as classes from './modules/classes.js'
import * as locations from './modules/locations.js'
import * as company from './modules/company.js'
import * as invoicingtermscoditions from './modules/invoice-terms-conditions.js'
import * as reports from './modules/reports.js'
import * as expenses from './modules/expenses.js'
import * as invoices from './modules/invoices.js'
import * as creditNotes from './modules/credit-notes.js'
import * as emailSettings from './modules/email-settings.js'
import * as patterns from './modules/patterns.js'
import * as tags from './modules/tags.js'
import * as documents from './modules/documents.js'
import * as quotes from './modules/quotes.js'

Vue.use(Vuex)
export const store = new Vuex.Store({
  modules: {
    auth,
    clients,
    students,
    schools,
    classtypes,
    users,
    roles,
    classes,
    locations,
    company,
    invoicingtermscoditions,
    reports,
    expenses,
    invoices,
    creditNotes,
    emailSettings,
    patterns,
    tags,
    documents,
    quotes
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js